import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import UiTopNavProfile from "./UiTopNavProfile";
import TopNavBar from "./TopNavBar";
import UiHeaderWr from "./UiHeaderWr";
import { UiSingleContainer } from "../../../grid-container/GridContainer";

import { isMobile } from "react-device-detect";
import UiCustomWr from "../UiCustomWr";
import { useDispatch, useSelector } from "react-redux";
import {
    getParticipantProfileRequest,
    getUSerDetailsRequest,
} from "../../../../../_redux/_actions";

export default function CustomTopHeader(props) {
    const [headerchange, setHeaderchange] = useState(false);

    const actionDispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });

    // useEffect(() => {
    //     actionDispatch(getParticipantProfileRequest());
    //     actionDispatch(getUSerDetailsRequest());
    //     if (location.pathname === "/app/campaigns") {
    //         if (!auth?.userProfileDetails?.dealerParticipant) {
    //             navigate("/app/home");
    //         }
    //     }
    // }, [location]);

    useEffect(function () {
        if (!isMobile) {
            let scrollTop = window.scrollY;
            let activeLink = document.querySelector(".sb-slider-bottom-line");

            window.addEventListener("scroll", () => {
                if (activeLink !== null) {
                    if (scrollTop >= activeLink.offsetTop) {
                        setHeaderchange(true);
                    } else {
                        setHeaderchange(false);
                    }
                }
            });
        }
    }, []);

    return (
        <>
            <UiCustomWr>
                <UiHeaderWr>
                    <UiSingleContainer fluid="fluid">
                        <TopNavBar />
                        <UiTopNavProfile />
                    </UiSingleContainer>
                </UiHeaderWr>
            </UiCustomWr>
        </>
    );
}
